module.exports = __webpack_public_path__ + "static/media/rectus_femoris_left_weak.a8a6bfad.png";